import { post, get, deletefn, putfun } from './http.js'
export default {
  // 我的订单
  async orderUser (params) {
    return await get ('/order-user',params)
  },
  // 订单分类
  async orderCategoryList (params) {
    return await get ('/order-categories',params)
  },
  // 订单列表
  async orderList (params) {
    return await get ('/order',params)
  },
  // 订单详情
  async orderDetail (params) {
    return await get (`/order/${params}`)
  },
  // 附件列表
  async fileList (params) {
    return await get (`/order-user/${params}`)
  },
  // 下载附件
  async downloadFile (params) {
    return await get (`/order-user/${params}`)
  },
  // 附件下载记录
  async downloadSource (params) {
    return await putfun (`/basic-file/`,params)
  },
  //订单补差价
  async orderDifference (params) {
    return await post (`/order-difference/${params.id}`,params)
  },
  // 订单评分
  async orderScore (params) {
    return await post ('/common/rate',params)
  },
  // 订单补差价列表
  async differenceList (params) {
    return await get (`/order-difference`,params)
  },
  // 订单样稿提交
  async orderSample(params){
    return await post (`/order-sample/${params.id}`,params)
  },
  // 已上传样稿列表
  async orderSampleList(params){
    return await get (`/order-sample/${params}`)
  },
  // 已上传最终文件列表
  async orderFileList(params){
    return await get (`/source-file`,params)
  },
  // 上传源文件
  async orderFile(params){
    return await putfun (`/source-file/${params.id}`,params)
  },
  // 申请接单
  async applyOrder(params){
    return await post (`/order-user/${params}`)
  },
  // 确认接单
  async agreeOrder(params){
    return await putfun (`/order-user/${params.id}`,params)
  },
}



// WEBPACK FOOTER //
// ./src/request/task.js